import React from "react";
import { ClientLayoutPageSubHeader, FiltersAppliedWarningMessage, Main, ThemedIcon } from "../../components/utilities";
import { ClientApplicationsDefaultFilters, FilterProvider, useFilterContext } from "../../hooks/FilterContext";
import withProviders from "../../hooks/withProviders";
import ClientApplicationsGrid from "../../features/clientapplications/index.js";
import { FormInputWithSearchIcon } from "../../components/forms";

const ClientApplicationsPage = () => {
   
    const {
        setFilter
    } = useFilterContext();

    const [isFiltersShown, setIsFiltersShown] = React.useState(false);
    const [formSearchTerm, setFormSearchTerm] = React.useState("");
    
    React.useEffect(() => {
        const updateFilters = setTimeout(() => {
            setFilter(original => {
                        return {
                            ...original,
                            searchTerm: formSearchTerm
                        }})                        
        }, 500);
        return () => clearTimeout(updateFilters);
    }, [ formSearchTerm ]);

    return <React.Fragment>
        <Main className="d-flex flex-column">
            <ClientLayoutPageSubHeader>
                <div className="d-flex justify-content-end align-items-center">
                    <FormInputWithSearchIcon
                        className="w-25 mx-1"
                        placeholder="Search Applications"
                        value={formSearchTerm}
                        disableAnimations={true}
                        onChange={(e) => setFormSearchTerm(e.target.value)}

                    />
                </div>
            </ClientLayoutPageSubHeader>
            <section className="px-4 my-3 h-100">
                <ClientApplicationsGrid />
            </section>
        </Main>
    </React.Fragment>
}

export default withProviders([FilterProvider, { filterStore: "events", defaultFilters: ClientApplicationsDefaultFilters }])(ClientApplicationsPage);